"use client";

import Link from "next/link";
import React from "react";
import styles from "./HeaderNav.module.scss";
import dynamic from "next/dynamic";
import { headerNavData } from "./HeaderNav.data";

const HeaderNavModalClient = dynamic(
  () => import("@components/atoms/HeaderNavModalClient"),
  {
    ssr: false,
    loading: () => null,
  }
);

const HeaderNav = () => {
  return (
    <div className={styles.navContainer}>
      <Link
        href={`${process.env.NEXT_PUBLIC_FRONTEND_HOST}/garage-storefront/service-centre`}
        className={styles.navLink}
        prefetch={false}
      >
        Service car
      </Link>

      <HeaderNavModalClient
        type="buyCar"
        headerNavData={headerNavData}
      >
        <button className={styles.navLink}>
          Buy car
        </button>
      </HeaderNavModalClient>

      <Link
        href={`${process.env.NEXT_PUBLIC_FRONTEND_HOST}/used/car-exchange/`}
        className={styles.navLink}
        prefetch={false}
      >
        Exchange car
      </Link>

      <HeaderNavModalClient
        type="blog"
        headerNavData={headerNavData}
      >
        <button className={styles.navLink}>
          News
        </button>
      </HeaderNavModalClient>

      <div className={styles.seoNavStructure} aria-hidden="true">
        <nav>
          <ul>
            <li>
              <strong>Buy Car Navigation:</strong>
              <ul>
                {headerNavData.buyCar.map((item, index) => (
                  <li key={`buy-${index}`}>
                    <Link href={item.href} className={styles.seoNavLink}>
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            
            <li>
              <strong>Blog Navigation:</strong>
              <ul>
                {headerNavData.blog.map((item, index) => (
                  <li key={`blog-${index}`}>
                    <Link href={item.href} className={styles.seoNavLink}>
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

          </ul>
        </nav>
      </div>
    </div>
  );
};

export default HeaderNav;
